// extracted by mini-css-extract-plugin
module.exports = {"box":"TaskBox_box__nV2S_","grow":"TaskBox_grow__5jQW8","boxRight":"TaskBox_boxRight__Bov5G"};